import React from 'react';

const Home = () => (
  <main className="home-main">
    <h1 className="home-heading">Welcome to our page!</h1>
    <p className="home-para">
      End of the day, life itself is a math problem. Everything can be explained through math,
      including the rotation of our Earth or creation of
      the human kind. You will also find some inspirational math quotes for students with donuts
    </p>
    <p className="home-para">
      There are certain calculations I should like to make with you,
      To be sure that your deductions will be logical and true;
      And remember, &apos;Patience, Patience,&apos; is the watchword of a sage,
      Not to-day nor yet to-morrow can complete a perfect age.
    </p>
  </main>
);

export default Home;
